import {
  KHANACADEMY_VIDEO_SUCCESS,
  KHANACADEMY_VIDEO_FAIL,
  KHANACADEMY_MENU_SUCCESS,
  KHANACADEMY_MENU_FAIL,
  KHANACADEMY_MENU_DETAIL_SUCCESS,
  KHANACADEMY_MENU_DETAIL_FAIL,
  KHANACADEMY_UNIT_VIDEO_SUCCESS,
  KHANACADEMY_UNIT_VIDEO_FAIL,
  KHANACADEMY_TOPIC_VIDEO_SUCCESS,
  KHANACADEMY_TOPIC_VIDEO_FAIL,
} from "../types";
import axios from "axios";
import * as Sentry from "@sentry/react";

export const getKhanAcademyVideo = (id) => {
  return async (dispatch) => {
    const config = { header: { "Content-Type": "application/json" } };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ENV}/api/khanacademy/${id}`,
        config
      );

      dispatch({ type: KHANACADEMY_VIDEO_SUCCESS, payload: res?.data });
    } catch (err) {
      Sentry.captureException(err);
      dispatch({
        type: KHANACADEMY_VIDEO_FAIL,
        payload: err?.response?.data?.message,
      });
    }
  };
};
export const getKhanAcademyMenu = (id) => {
  return async (dispatch) => {
    const config = { header: { "Content-Type": "application/json" } };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ENV}/api/khanacademy/menu/${id}`,
        config
      );

      dispatch({ type: KHANACADEMY_MENU_SUCCESS, payload: res?.data });
    } catch (err) {
      Sentry.captureException(err);
      dispatch({
        type: KHANACADEMY_MENU_FAIL,
        payload: err?.response?.data?.message,
      });
    }
  };
};

export const getKhanAcademyMenuDetail = (topic, name) => {
  return async (dispatch) => {
    const config = { header: { "Content-Type": "application/json" } };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ENV}/api/khanacademy/menu/withSlug/${topic}/${name}`,
        config
      );
      dispatch({ type: KHANACADEMY_MENU_DETAIL_SUCCESS, payload: res?.data });
    } catch (err) {
      Sentry.captureException(err);
      dispatch({
        type: KHANACADEMY_MENU_DETAIL_FAIL,
        payload: err?.response?.data?.message,
      });
    }
  };
};

export const getKhanAcademyMenuUnitVedio = (topic, name, unit) => {
  return async (dispatch) => {
    const config = { header: { "Content-Type": "application/json" } };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ENV}/api/khanacademy/menu/${topic}/${name}/${unit}`,
        config
      );
      dispatch({ type: KHANACADEMY_UNIT_VIDEO_SUCCESS, payload: res?.data });
    } catch (err) {
      Sentry.captureException(err);
      dispatch({
        type: KHANACADEMY_UNIT_VIDEO_FAIL,
        payload: err?.response?.data?.message,
      });
    }
  };
};

export const getKhanAcademyMenuTopicVedio = (topic, name, unit, slug) => {
  return async (dispatch) => {
    const config = { header: { "Content-Type": "application/json" } };
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ENV}/api/khanacademy/menu/${topic}/${name}/${unit}/${slug}`,
        config
      );
      dispatch({ type: KHANACADEMY_TOPIC_VIDEO_SUCCESS, payload: res?.data });
    } catch (err) {
      Sentry.captureException(err);
      dispatch({
        type: KHANACADEMY_TOPIC_VIDEO_FAIL,
        payload: err?.response?.data?.message,
      });
    }
  };
};
export const clearKhanAcademyMenu = () => (dispatch) => {
  dispatch({ type: KHANACADEMY_MENU_DETAIL_FAIL });
};
export const clearkhanAcademyUnitMenu = () => (dispatch) => {
  dispatch({ type: KHANACADEMY_TOPIC_VIDEO_FAIL });
};
